<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 7.5L10.0758 13.5L5 7.5381L15 7.5Z"
      fill="#3F3F3F"
    />
  </svg>
</template>
